import e from "@dialpad/dialtone-tokens/layered/themes/tokens-plum-colors.css?inline";
//#region themes/plum.js
var t = { brand: {
	css: e,
	name: "plum"
} };
//#endregion
export { t as default };
